module.exports = __webpack_public_path__ + "img/title5.7018944b.png";